module.exports = __webpack_public_path__ + "img/banner.f583e026.jpg";